"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextQuestionModule = void 0;
const base_1 = require("./base");
const util_1 = require("./util");
class TextQuestionModule extends base_1.InputModule {
    constructor({ multiline = false, ...rest }) {
        super(rest);
        this._type = "TextQuestion";
        this.multiline = multiline;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            return {
                actionRequired: this.actionRequired,
                id: this.id,
                label: this.label,
                multiline: this.multiline,
                noBorder: this.noBorder,
                type: this.type,
                required: this.required,
                hidden: this.hidden,
            };
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        var _a;
        const { required, label, ...base } = this.toBuilderConfig();
        const surveyConfigModule = {
            ...base,
            actionRequired: this.actionRequired,
            header: { children: (_a = label[this.languageCode]) !== null && _a !== void 0 ? _a : "" },
        };
        if (required) {
            surveyConfigModule.validation = (0, util_1.addRequiredValidation)();
        }
        return surveyConfigModule;
    }
    editProps() {
        var _a;
        return {
            id: this.id,
            type: this.type,
            question: (_a = this.label[this.languageCode]) !== null && _a !== void 0 ? _a : "",
            actionRequired: this.actionRequired,
            hidden: this.hidden,
        };
    }
}
exports.TextQuestionModule = TextQuestionModule;
//# sourceMappingURL=TextQuestion.js.map